export default {
  data() {
    return {
      validacaoId: "transplantes",
      errors: {
        campoOutrosTranplantes: "",
        flag: false
      },
      mensagemDeErro: {
        transplantes: "",
        campoOutros: ""
      }
    };
  },
  computed: {
    temErrors() {
      let temErro = false;

      Object.values(this.errors).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      Object.values(this.mensagemDeErro).forEach(err => {
        if (err.length > 0) {
          temErro = true;
        }
      });
      return temErro;
    }
  },
  methods: {
    chequeOutrosTranplantes() {
      if (!this.transplantes) return;

      if (this.transplantes.length < 1 && this.clickSwitch.transplante) {
        this.mensagemDeErro.transplantes =
          "Selecione ao menos 1 tipo de Transplante";
      } else {
        this.mensagemDeErro.transplantes = "";
      }

      if (this.outrosTranplantes && !this.campoOutrosTranplantes) {
        this.errors.campoOutrosTranplantes = "Este campo é Obrigatório!";
      } else {
        this.errors.campoOutrosTranplantes = "";
      }
    },
    flaggedTransplante() {
      if (!this.clickSwitch.transplante) return;
    }
  },

  watch: {
    transplantes: "chequeOutrosTranplantes",
    temErrors(boo) {
      const payload = {
        temErro: boo,
        validacaoId: this.validacaoId
      };
      this.$emit("error", payload);
    },
    campoOutrosTranplantes: function(novoValor) {
      if (
        novoValor.length > 0 ||
        (novoValor.length == 0 && this.transplantes.length == 0)
      ) {
        this.errors.campoOutrosTranplantes = "";
      } else {
        this.errors.campoOutrosTranplantes = "Este campo é Obrigatório!";
      }
    },
    "clickSwitch.transplante": function(novoValor) {
      if (!this.transplantes) return;

      if (!novoValor) {
        this.transplantes = [];
        this.errors.campoOutrosTranplantes = "";
      }

      if (novoValor && this.transplantes.length < 1) {
        this.mensagemDeErro.transplantes = "Este campo é obrigatório";
        console.log("tem erro");
      } else {
        this.mensagemDeErro.transplantes = "";
      }
    }
  }
};
